import { NotificationFactoryComponent } from "./types";

const context = require.context("./typeIntegration", true, /[a-zA-Z]\.tsx/);

export default context.keys().reduce<NotificationFactoryComponent[]>((out, key) => {
  const module = context(key);
  out.push(module.default);
  return out;
}, []);
